<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-list</v-icon>
      <h2 class="title">Programa</h2>
    </v-card-title>
    <v-card-text v-if="value">
      <v-row justify="center">
        <v-img
          v-if="value.imagen"
          :src="urlImg"
          max-width="500"
          max-height="300"
        ></v-img>
      </v-row>
      <p class="headline text-center mt-2">{{value.nombre}}</p>
      <p class="subtitle-2 text-center text-capitalize">{{value.dia}} - {{value.horario}}</p>
      <p>{{value.descripcion}}</p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { host } from '../config'
export default {
  name: 'show-programa',
  props: ['value'],
  computed: {
    urlImg () {
      if (this.value.imagen) {
        return `${host}${this.value.imagen.url}`
      } else {
        return null
      }
    }
  }
}
</script>
